import { ComponentPropsWithoutRef, useState, useCallback, useRef } from "react";
// components
import ModalLayout from "components/modal/modal-layout/ModalLayout";
import ScheduleCreator from "./components/schedule-creator";
// hooks
import { useCalendarTime } from "../../../../../../contexts/CalendarTimeContext";
// utils
import createParsedAvailableTimePeriod from "../../../../../../../../utils/createParsedAvailableTimePeriod";
import { formatParsedAvailableTimePeriodToAvailableTimePeriod } from "../../utils/formatParsedAvailableTimePeriodToAvailableTimePeriod";

type Props = ComponentPropsWithoutRef<typeof ModalLayout> & {
  onChange: (v: Schedule[number]) => void;
};

/**
 * contains logic for schedule creator ui
 */
const ScheduleCreatorContainer = ({ onHide, onChange, ...rest }: Props) => {
  const ref = useRef<Pick<HTMLFormElement, "checkValidity" | "reset"> | null>(
    null,
  );

  const { currentCalendarTimezone } = useCalendarTime();

  const [value, setValue] = useState<ParsedAvailableTimePeriod>(
    createParsedAvailableTimePeriod(currentCalendarTimezone),
  );

  const handleHide = useCallback(() => {
    // reset to initial state
    onHide();
    setValue(createParsedAvailableTimePeriod(currentCalendarTimezone));
    return ref.current?.reset();
  }, [onHide, currentCalendarTimezone]);

  const handleApply = useCallback(() => {
    // validate
    const validity = ref.current!.checkValidity();

    // if has error, stop and show error
    if (!validity) {
      // if has error, stop and show error
      return;
    }
    onChange(formatParsedAvailableTimePeriodToAvailableTimePeriod(value));
    handleHide();
  }, [handleHide, onChange, value]);

  return (
    <ScheduleCreator
      {...rest}
      ref={ref}
      onHide={handleHide}
      value={value}
      onChange={setValue}
      onApply={handleApply}
    />
  );
};

export default ScheduleCreatorContainer;
